// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"5e93c19d","255":"1064a52f","573":"f858ef48","858":"68b7d1ca","948":"99441cd2"}[chunkId] + ".chunk.css";
};